var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', [_c('v-sheet', {
    staticClass: "text-center mb-20 mb-lg-40"
  }, [_c('h3', {
    staticClass: "tit mb-8 mb-lg-16"
  }, [_vm._v(" 작성 완료 ")]), _c('p', {
    staticClass: "page-text--lg grey-6--text"
  }, [_vm._v(" 이력서 작성이 완료 되었습니다. "), _c('br'), _vm._v(" 해당 내용으로 지원하시겠습니까? ")])]), _c('div', {
    staticClass: "v-btn-group mt-0"
  }, [_c('v-btn', {
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "outlined": "",
      "color": "grey-d"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('prev');
      }
    }
  }, [_c('span', {
    staticClass: "grey-6--text"
  }, [_vm._v("이전으로")])]), _c('v-btn', {
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.apply
    }
  }, [_c('span', [_vm._v("지원하기")])])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }